// Minimal client for public site settings
export type SubscriptionRules = Record<string, { shares?: number | null; views?: number | null; days?: number | null }>;
export type PublicSiteSettingsResponse = {
  homepageSettings?: any;
  subscriptionRules?: SubscriptionRules;
  siteSeo?: any;
};

export async function getPublicSiteSettings(): Promise<PublicSiteSettingsResponse> {
  const res = await fetch('/api/site-settings', { headers: { 'Accept': 'application/json' } });
  if (!res.ok) throw new Error('Failed to load site settings');
  return res.json();
}

// Admin clients
export type AdminSiteSettingsResponse = {
  id: string | null;
  homepageSettings: any;
  paymentSettings: any;
  subscriptionRules: SubscriptionRules;
  siteSeo?: any;
  authenticationSettings?: any;
  lastUpdatedBy?: { id?: string; email?: string; role?: string; at?: string } | null;
};

export async function getAdminSiteSettings(): Promise<AdminSiteSettingsResponse> {
  const token = typeof window !== 'undefined' ? localStorage.getItem('dev_admin_token') : null;
  const res = await fetch('/api/admin/site-settings', { headers: { 'Accept': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) } });
  if (!res.ok) throw new Error('Failed to load admin site settings');
  return res.json();
}

export async function updateAdminSiteSettings(payload: Partial<AdminSiteSettingsResponse>): Promise<AdminSiteSettingsResponse> {
  const token = typeof window !== 'undefined' ? localStorage.getItem('dev_admin_token') : null;
  const res = await fetch('/api/admin/site-settings', { method: 'PUT', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body: JSON.stringify(payload || {}) });
  if (!res.ok) throw new Error('Failed to save admin site settings');
  return res.json();
}
